import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * ToastContainerComponent wraps react-toastify's ToastContainer for global toast notifications.
 * Place this component at the root of your app (e.g., in index.tsx or App).
 */
const ToastContainerComponent: React.FC = () => (
  <ToastContainer
    position="top-right"
    autoClose={2000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    
  />
);

export default ToastContainerComponent;
